
import { Link } from 'react-router-dom';

interface HeroSectionProps {
  onScrollToCalculator: () => void;
}

/**
 * HeroSection component displays a full‑width hero image with a
 * headline, description and two call‑to‑action buttons.
 *
 * @param onScrollToCalculator - Callback to scroll to the calculator section.
 */
export default function HeroSection({ onScrollToCalculator }: HeroSectionProps) {
  return (
    <section className="relative h-[520px] flex items-center justify-center">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/d812b1bcc20edc9cb656ee0282bc297d.jpg"
          alt="Aerial view of managed timber forest"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/45"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white w-full">
        <h1 className="text-5xl font-bold mb-6 leading-tight">
          Transparent Pricing for Timber &amp; Forestry Services
        </h1>
        <p className="text-xl mb-8 leading-relaxed max-w-3xl mx-auto">
          Estimate your project cost by acreage, service type, and complexity. Final pricing reflects terrain, canopy density, and deliverable scope.
        </p>

        <div className="flex gap-4 justify-center">
          <button
            type="button"
            onClick={onScrollToCalculator}
            className="px-8 py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition whitespace-nowrap cursor-pointer"
          >
            Estimate Your Project
          </button>

          <Link
            to="/instant-quote"
            className="px-8 py-3 bg-white text-stone-900 rounded-lg font-semibold hover:bg-stone-100 transition whitespace-nowrap cursor-pointer"
          >
            Request a Firm Quote
          </Link>
        </div>
      </div>
    </section>
  );
}
